import React, { useState, useEffect } from 'react'
import LoginHeader from '../../../Login_header'
import Menu from '../../../Menu'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import LocationSelector from '../../../LocationSelector';
import { useNavigate } from 'react-router-dom';
import * as Common from "../../../Common";
import * as Picklist from "../../../Picklist";
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/async';
import Dialog from '../../../Dialog';
import $ from 'jquery';

const Remittence_tour_reports = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState("O");

    const [filterLocation, setFilterLocation] = useState('A');
    const [repLocation, setRepLocation] = useState(null);
    const [repDate, setRepDate] = useState(new Date());
    const [filterPurpose, setFilterPurpose] = useState('A');
    const [repPurpose, setRepPurpose] = useState(null);
    const [filterParty, setFilterParty] = useState('A');
    const [repParty, setRepParty] = useState(null);

    const [purposeCode, setPurposeCode] = useState(0);
    const [partyGroup, setPartyGroup] = useState(0);
    const [partyAccount, setPartyAccount] = useState(0);
    const [generateType, setGenerateType] = useState('D');

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_REMITTENCE_TOUR'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    // const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
    //     setLocationCode(newLocationCode);
    //     setSelectedItems(newSelectedItems);
    //     setRadioType(newRadioType);
    // }

    const handleChangeRepLocation = (value) => {
        console.log("This is Picklist Location!", value);
        setRepLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
    }

    const handleRepPurposeChange = (value) => {
        console.log("This is Purpose Picklist!", value);
        setRepPurpose(value);
        const pur = value.id.split('^');
        setPurposeCode(pur[1]);
    }

    const handleRepPartyChange = (value) => {
        console.log("This is Party Picklist!", value);
        setRepParty(value);
        const prty = value.id.split('^');
        setPartyGroup(prty[1]);
        setPartyAccount(prty[2]);
    }

    const handleGenerate = () => {
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(repDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        if ((filterLocation === 'O' && repLocation === null) || (filterPurpose === 'O' && repPurpose === null) || (filterParty === 'O' && repParty === null) || !repDate) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((filterLocation === 'O' && repLocation === null) ? "Select Location." : '');
            msg[i++] = (!repDate ? "Date." : '');
            msg[i++] = ((filterPurpose === 'O' && repPurpose === null) ? "Purpose." : '');
            msg[i++] = ((filterParty === 'O' && repParty === null) ? "Party." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                location: locationCode,
                date: Common.dateYMD(repDate),
                filterLocation: filterLocation,
                filterPurpose: filterPurpose,
                filterParty: filterParty,
                groupCode: partyGroup,
                accountCode: partyAccount,
                generateType: generateType,
                purposeCode: purposeCode,
            };
            if (generateType === 'D') {
                Common.callDownloadApiPost1(Common.apiRemittenceReport, "post", [sid, 'getData', JSON.stringify(obj)], (result) => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else if (generateType === 'V') {
                Common.callApi(Common.apiRemittenceReport, [sid, 'getData', JSON.stringify(obj)], (result) => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });
            }
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Remittence Tour Reports</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    {/* <Col className='col-md-6 col-6'>
                        <Form.Label>Location Filter</Form.Label><br />
                        <LocationSelector onDataFromChild={handleDataFromChild} />
                    </Col> */}
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterLocation} onChange={(e) => setFilterLocation(e.target.value)}
                                required>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterLocation === 'O' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={repLocation}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleChangeRepLocation}
                                // isDisabled={branchDisable === "true"}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col></> : null}
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={repDate}
                                onChange={(date) => setRepDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Purpose<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterPurpose} onChange={(e) => setFilterPurpose(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="O">One</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterPurpose === 'O' ?
                        <Col className="col-md-3 col-6">
                            <Form.Group>
                                <Form.Label>Purpose<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={repPurpose}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchPurposePicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleRepPurposeChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                        : null}
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Party Type<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterParty} onChange={(e) => setFilterParty(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="O">One</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterParty === 'O' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Party<span className='colorThemeRed'>*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={repParty}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE  , DEALER , ISSUER', locationCode)}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleRepPartyChange}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                        : null}
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Remittence_tour_reports
